import { frontendURL } from '../../../helper/URLHelper';
import CrmIndex from './Index.vue';

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    component: CrmIndex,
    name: 'crm_view',
    meta,
  },
];
